import { RefObject, useEffect } from "react";
import { useRemoteNavigation } from "../contexts/RemoteNavigationContext";
import { useDevice } from "../contexts/DeviceContext";
import { NavigationData } from "../../config/interactive/types";

export function useRegisterFocusable(
	navData: NavigationData,
	focusableRef: RefObject<HTMLElement | HTMLAnchorElement | null>,
) {
	const { registerElement, unregisterElement } = useRemoteNavigation();
	const { isMobile } = useDevice();

	useEffect(() => {
		if (isMobile) return;
		if (!focusableRef || !focusableRef.current) return;
		registerElement(navData.id, focusableRef as RefObject<HTMLElement>);
		return () => unregisterElement(navData.id);
	}, [navData.id, focusableRef, registerElement, unregisterElement]);

	return null;
}
